import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=b6c7a3ba&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6c7a3ba')) {
      api.createRecord('b6c7a3ba', component.options)
    } else {
      api.reload('b6c7a3ba', component.options)
    }
    module.hot.accept("./Welcome.vue?vue&type=template&id=b6c7a3ba&", function () {
      api.rerender('b6c7a3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_dev/Welcome.vue"
export default component.exports